/* eslint-disable css-modules/no-undef-class, css-modules/no-unused-class */
import { FC, useCallback, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Notification, EmptyNotification, RightSidePanel } from 'learning-panel-components';
import { NotificationsProps } from './notificationsTypes';
import NewsNotification from './newsSmallNotification/notification';
import NewsOpenNotification from './newsOpenNotification/notification';
import { NotificationUI } from './notificationsUI';
import './notifications.scss';

const Notifications: FC<NotificationsProps> = (props: NotificationsProps) => {
    const { notifications, loadMore, refFunction, isEmpty, rightSideRef, leanUser } = props;
    const [openedNotification, setOpenedNotification] = useState<NotificationUI>();
    const [openedNotificationId, setOpenedNotificationId] = useState<string>('');
    const [showOpenNotification, setShowOpenNotification] = useState<boolean>(false);
    let notificationsTop = 0;

    const observer = useRef<IntersectionObserver | null>(null);
    const lastNotificationElementRef = useCallback(
        node => {
            if (observer.current) observer.current.disconnect();
            observer.current = new IntersectionObserver(entries => {
                if (entries[0].isIntersecting) {
                    loadMore();
                }
            });
            if (node) observer.current.observe(node);
        },
        [loadMore]
    );

    const setOpenNotification = (openedNotificationId: string) => {
        const openedNotificationTmp = notifications.filter(notification => notification.id === openedNotificationId);
        setOpenedNotificationId(openedNotificationId);
        setOpenedNotification(openedNotificationTmp[0]);
        setShowOpenNotification(true);
    };

    const getElementHeight = (html: string) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const imageElement = doc.querySelector('img');
        return imageElement ? 22 : 13;
    };

    return (
        <>
            {createPortal(
                <div
                    ref={rightSideRef}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 1266,
                        pointerEvents: 'none'
                    }}
                >
                    <RightSidePanel
                        isOpen={showOpenNotification}
                        onClose={() => {
                            setShowOpenNotification(false);
                            setOpenedNotificationId('');
                        }}
                        useBackgrounds={false}
                        hideBackdrop
                        includeRefsElement={[refFunction]}
                        initialRight="-11rem"
                        finalRight="27rem"
                        top={leanUser ? '7.6875rem' : '4.375rem'}
                    >
                        <NewsOpenNotification
                            title={openedNotification?.title || ''}
                            sentDate={openedNotification?.date || new Date()}
                            content={openedNotification?.content || ''}
                            onClose={() => setShowOpenNotification(false)}
                        />
                    </RightSidePanel>
                </div>,
                document.body
            )}
            <div className="notifications-wrapper" style={{ '--top': leanUser ? '7.6875rem' : '4.375rem' } as any}>
                <div ref={refFunction}>
                    {!isEmpty ? (
                        notifications.map((notification, i) => {
                            let top = 0;
                            let elementHeight = 0;

                            if (notification.type === 'News') {
                                elementHeight = getElementHeight(notification.content);
                                top = notificationsTop;
                                notificationsTop += elementHeight;
                            } else {
                                top = notificationsTop;
                                notificationsTop += 6.5;
                            }

                            return notification.type === 'News' ? (
                                <NewsNotification
                                    id={notification.id}
                                    title={notification.title}
                                    sentDate={notification.date}
                                    contentHtml={notification.content}
                                    top={top}
                                    onSeeMoreClick={setOpenNotification}
                                    key={notification.id}
                                    refFunction={
                                        i + 1 === notifications.length ? lastNotificationElementRef : undefined
                                    }
                                    height={`${elementHeight}rem`}
                                    isActive={notification.id === openedNotificationId}
                                />
                            ) : (
                                <Notification
                                    top={top}
                                    key={notification.id}
                                    sentDate={notification.date}
                                    content={notification.content}
                                    refFunction={
                                        i + 1 === notifications.length ? lastNotificationElementRef : undefined
                                    }
                                    title={''}
                                />
                            );
                        })
                    ) : (
                        <EmptyNotification />
                    )}
                </div>
            </div>
        </>
    );
};

export default Notifications;
